import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface CartToastData {
  title: string;
  subtitle?: string;
  imageUrl?: string;
}

@Injectable({
  providedIn: 'root'
})
export class CartToastService {
  private toastSubject = new Subject<CartToastData>();
  toast$ = this.toastSubject.asObservable();

  show(data: CartToastData) {
    this.toastSubject.next(data);
  }
}
